import React, { useState } from 'react'
import './AddInfoModal.scoped.sass'
import modalService from '@/services/modal.service'

import { Button } from '@/components/Button/Button'
import { InputMask } from '@/components'
import { ReactComponent as CloseIcon } from '@/assets/icons/close-icon.svg'
import contactsService from '@/app-domains/contacts/contacts.service'
import store from '@/core/store'
import isEmail from 'validator/lib/isEmail'
import ToastService from '@/components/Toast/Toast.service'

const AddInfoModal = (props) => {
  const { type } = props
  const contact = JSON.parse(JSON.stringify(props.contact))
  const [newEmail, setNewEmail] = useState()
  const [newPhoneNumber, setNewPhoneNumber] = useState()
  const [newAddress, setNewAddress] = useState()
  
  if (type === 'phone-number') {
    return (
      <div className='main-container'>
        <div className='top-header'>
          <div className='top-header-message'>
            Add a new phone number
          </div>
          <div className='close-icon' onClick={() => modalService.close()}>
            <CloseIcon />
          </div>
        </div>
        <div className='input'>
          <InputMask placeholder='Phone number...' onInput={(value) => {
            setNewPhoneNumber(value)
          }} />
        </div>
        <div className='buttons-group'>
          <div className='cancel-button'>
            <Button content='Cancel' type='secondary' click={() => { modalService.close() }}/>
          </div>
          <div className='add-button'>
            <Button content='Add phone number' click={() => {
              contact.phones.push(`${newPhoneNumber}`)
              contactsService.editContact(contact)
              store.commit('CONTACT_LIST:UPDATED')
              store.commit('CONTACT_VIEW:UPDATED', contact)
              modalService.close()
            }} />
          </div>
        </div>
      </div>
    )
  } else if (type === 'email') {
    return (
      <div className='main-container'>
        <div className='top-header'>
          <div className='top-header-message'>
            Add a new email
          </div>
          <div className='close-icon' onClick={() => modalService.close()}>
            <CloseIcon />
          </div>
        </div>
        <div className='input'>
          <InputMask placeholder='Email...' onInput={(value) => {
            setNewEmail(value)
          }}/>
        </div>
        <div className='buttons-group'>
          <div className='cancel-button'>
            <Button content='Cancel' type='secondary' click={() => { modalService.close() }}/>
          </div>
          <div className='add-button'>
            <Button content='Add email' click={() => {
              if (!isEmail(newEmail)) {
                ToastService.show({
                  type: 'error',
                  title: 'Editing',
                  message: 'Email doesn\'t have a valid format',
                })
              
                return
              }
              contact.emails.push(newEmail)
              contactsService.editContact(contact)
              store.commit('CONTACT_LIST:UPDATED')
              store.commit('CONTACT_VIEW:UPDATED', contact)
              modalService.close()
            }}/>
          </div>
        </div>
      </div>
    )
  } else if (type === 'address') {
    return (
      <div className='main-container'>
        <div className='top-header'>
          <div className='top-header-message'>
            Add a new address
          </div>
          <div className='close-icon' onClick={() => modalService.close()}>
            <CloseIcon />
          </div>
        </div>
        <div className='input'>
          <InputMask placeholder='Address...' onInput={(value) => {
            setNewAddress(value)
          }}/>
        </div>
        <div className='buttons-group'>
          <div className='cancel-button'>
            <Button content='Cancel' type='secondary' click={() => { modalService.close() }}/>
          </div>
          <div className='add-button'>
            <Button content='Add email' click={() => {
              contact.addresses.push(`${newAddress}`)
              contactsService.editContact(contact)
              store.commit('CONTACT_LIST:UPDATED')
              store.commit('CONTACT_VIEW:UPDATED', contact)
              modalService.close()
            }}/>
          </div>
        </div>
      </div>
    )
  }
}

export default AddInfoModal
